<template>
  <div>
    <main class="main-content">
      <div class="page-content page-content--kilimanjaro">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="day-trips-activities" v-if="isLoad">
            <div class="page-title">
              <h2>Climbing Routes</h2>
              <div class="page-title__side">
                <div class="form-control-wrap">
                  <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
                <a
                  href="javascript:void(0)" class="btn btn--green btn--shadowed"
                  @click="$router.push('/climbing/routes/add')"
                >
                  <span>Add Route</span>
                </a>
              </div>
            </div>
            <div
              data-simplebar="data-simplebar"
              class="day-trips-activities__table-wrap day-trips-activities__table--kilimanjaro"
            >
              <div class="day-trips-activities__table">
                <div class="day-trips-activities__table__head">
                  <div class="col col-name" :style="{width: '25rem'}"><span>Name</span></div>
                  <div class="col col-mountains"><span>Mount</span></div>
                  <div class="col col-duration"><span>Duration</span></div>
                  <div class="col col-created" :style="{width: '15rem'}"><span>Created</span></div>
                  <div class="col col-update"><span>Last Update</span></div>
                </div>

                <a
                  href="javascript:void(0)"
                  class="day-trips-activities__table__row"
                  v-for="(item, index) in routes.slice((page - 1) * 15, ((page - 1) * 15) + 15)"
                  :key="item.id"
                >
                  <div class="col col-name" :style="{width: '25rem'}"><span>{{ item.name }}</span></div>
                  <div class="col col-mountains"><span>{{ item.mountTitle }}</span></div>
                  <div class="col col-duration"><span>{{ item.durationDays }} days</span></div>
                  <div class="col col-created" :style="{width: '15rem'}"><span>{{ item.createdAt }}</span></div>
                  <div class="col col-update"><span>{{ item.updatedAt }}</span></div>
                  <div class="col col-action">
                    <button
                      type="button"
                      class="day-trips-activities__table__dropdown-trigger"
                      @click="openMenu(item.id)"
                    >
                      <svg width="1em" height="1em" class="icon icon-more ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                      </svg>
                      <div
                        :class="['edit-popup edit-popup--short',
                          { 'toup' : index + 1 === routes.slice((page - 1) * 15, ((page - 1) * 15) + 15).length && index + 1 !== 1 }]"
                        v-if="item.menu"
                      >
                        <div class="form-control-group">
                          <button
                            type="button" class="btn form-control-action"
                            @click="$router.push('/climbing/routes/' + item.id)"
                          >
                            <span class="form-control-action__icon icon--green">
                              <svg width="1em" height="1em" class="icon icon-edit ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                              </svg>
                            </span>
                            <span class="form-control-action__text">Edit</span>
                          </button>
                        </div>
                        <div class="form-control-group">
                          <button
                            type="button"
                            class="btn form-control-action"
                            @click="$emit('deleteModalHandler', {
                                entity: 'Climbing Route',
                                name: item.name,
                                handler: deleteIslandHandler,
                                id: item.id
                            })"
                          >
                            <span class="form-control-action__icon icon--red">
                              <svg width="1em" height="1em" class="icon icon-close">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </span>
                            <span class="form-control-action__text">Delete</span>
                          </button>
                        </div>
                      </div>
                    </button>
                  </div>
                </a>
              </div>
            </div>
            <Pagination :page="page" :pageCount="pageCount" @pageController="pageController" />
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import Pagination from '@/components/Pagination'

import {
  getRoutesAll,
  deleteRoute
} from '@/utilites/api'

export default {
  components: {Pagination},
  data() {
    return {
      search: '',
      routes: [],
      routesData: [],
      page: 1,
      pageCount: 0,
      isLoad: false
    }
  },
  props: ['user'],
  methods: {
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.routes.length / 15)
    },
    updateData() {
      this.isLoad = false
      getRoutesAll(this.user.access_token)
          .then(res => {
            this.routes = res.map(item => ({
              ...item,
              menu: false
            })).sort((a, b) => a.durationDays > b.durationDays ? -1 : 1).sort((a, b) => a.name > b.name ? 1 : -1)
            this.routesData = res.map(item => ({
              ...item,
              menu: false
            })).sort((a, b) => a.durationDays > b.durationDays ? -1 : 1).sort((a, b) => a.name > b.name ? 1 : -1)
            this.isLoad = true
          })
    },
    openMenu(id) {
      this.routes = this.routes.map(item => item.id === id ? {...item, menu: !item.menu} : {...item, menu: false})
    },
    deleteIslandHandler(id) {
      deleteRoute(this.user.access_token, id).then(() => this.updateData())
    }
  },
  beforeCreate() {
    document.title = 'Kilimajaro Routes'
  },
  mounted() {
    document.title = 'Kilimajaro Routes'
    this.updateData()
    window.addEventListener('click', event => {
      if (!event.target.closest('.day-trips-activities__table__dropdown-trigger')) {
        this.routes = this.routes.map(item => ({...item, menu: false}))
      }
    })
  },
  watch: {
    routes() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.routes = this.routesData
      }
      this.page = 1
      let filtered = this.routesData.filter(item => this.search.length ?
          ((item.name && item.name.toLowerCase().includes(this.search.toLowerCase()))) ?
              item : false : item).sort((a, b) => a.durationDays > b.durationDays ? -1 : 1).sort((a, b) => a.name > b.name ? 1 : -1)
      this.routes = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    }
  }
}
</script>
